import { useStoreContacts } from '@/entities/contact'

import { Contact } from '@/shared/types/api'
import { Room } from '@/shared/types/store'

/**
 * Контакт для аватара на экране звонка.
 * После COLP/CONP (перевод) room может быть с новым number, но pServedUser
 * ещё не матчится в книге — fallback на internalNumber / mobilePhone.
 */
export const resolveCallContact = (room: Room): Contact | undefined => {
  const { findByPServed, findByInternalNumber, findContactByMobilePhone } = useStoreContacts()
  const byPServed = findByPServed(room.pServedUser)
  if (byPServed) {
    return byPServed
  }

  if (!room.number) {
    return undefined
  }

  return findByInternalNumber(room.number) ?? findContactByMobilePhone(room.number)
}
